module.exports = __webpack_public_path__ + "static/media/bulk_upload_prt_consignee_data.5acad1be.csv";